import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-badge p-component'
};

export default BaseStyle.extend({
    name: 'badge-directive',
    classes
});
